import React, { useEffect, useState } from "react";
import { NewsImage_API } from "../../../../../../Utilities/APIs";
import Form from "../../../../../Partials/Layouts/Forms/Form";
import ImageInput from "../../../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import FormSubmitButton from "../../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import useAxiosInstance from "../../../../../../Utilities/Hooks/useAxiosInstance";
import VideoInput from "../../../../../Partials/Layouts/Forms/FormInputs/VideoInput/VideoInput";

function UpdateNewsImage({
  targetID,
  triggerFetch,
  setShowUpdateForm,
  setShowModal,
  newsId,
}) {
  const [image, setImage] = useState("");
  const [video, setVideo] = useState("");
  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    async function fetchAndSetNewsInfo() {
      const { data } = await axiosInstance.get(NewsImage_API + targetID);
      setImage(data.image);
      setVideo(data.video);
    }
    fetchAndSetNewsInfo();
  }, [targetID]);

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();
    itemData.append("image", image);
    if(video) itemData.append("video", video);
    itemData.append("newsId", newsId);

    const response = await axiosInstance.patch(
      NewsImage_API + targetID,
      itemData
    );

    if (response) {
      setShowUpdateForm(false);
      setShowModal(false);
      triggerFetch();
    }
  }

  return (
    <Form onSubmit={handleSubmit} hasImage>
      <ImageInput
        fieldId="1"
        state={image}
        setState={setImage}
        allowUpdateImage={true}
      >
        Upload Card Image
      </ImageInput>

      <VideoInput fieldId="2" state={video} setState={setVideo} />
      <FormSubmitButton text="Update" />
    </Form>
  );
}
export default UpdateNewsImage;
